<tt-page *ngIf="!!inputListCustomerDiscounts">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input-number *ngFor="let item of inputListCustomerDiscounts" [ttLabel]="item.discgrpprod_name" [(ttModel)]="item.pst" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
    </tt-card>
</tt-page>
